export default __webpack_public_path__ + "static/media/mohak.341afcf3.jpg";